import { resolveGatewayId } from './utils/resolveGatewayId';
import type { SubscriptionPlan } from './types';
import { AFFILIATION_TYPES } from './types';
import {
  PRICE_BASE_UNIVERSAL_STARTER_MONTHLY,
  PRICE_BASE_UNIVERSAL_STARTER_ANNUAL,
  PRICE_BASE_UNIVERSAL_MASTER_MONTHLY,
  PRICE_BASE_UNIVERSAL_MASTER_ANNUAL,
  PRICE_BASE_UNIVERSAL_ULTIMATE_MONTHLY,
  PRICE_BASE_UNIVERSAL_ULTIMATE_ANNUAL,
  PRICE_CAAMG_STARTER_MONTHLY,
  PRICE_CAAMG_STARTER_ANNUAL,
  PRICE_CAAMG_MASTER_MONTHLY,
  PRICE_CAAMG_MASTER_ANNUAL,
  PRICE_CAAMG_ULTIMATE_MONTHLY,
  PRICE_CAAMG_ULTIMATE_ANNUAL,
} from '../../components/ModalSubscriptionReached/constants';

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: 6849,
    gateway_id: resolveGatewayId({ prodId: 7022851, qaId: 7022851 }),
    name: 'One',
    description: 'Mensal',
    amount: 47,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'one',
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 6850,
    gateway_id: resolveGatewayId({ prodId: 7022859, qaId: 7022859 }),
    name: 'Ultimate',
    description: 'Mensal',
    amount: 117,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'ultimate_2026',
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 6851,
    gateway_id: resolveGatewayId({ prodId: 7022862, qaId: 7022862 }),
    name: 'Black',
    description: 'Mensal',
    amount: 227,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'black',
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 2613,
    gateway_id: resolveGatewayId({ prodId: 6645742, qaId: null }),
    name: '[Plano Base 2026] Starter',
    description: 'Mensal',
    amount: PRICE_BASE_UNIVERSAL_STARTER_MONTHLY,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'starter',
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 26,
    gateway_id: resolveGatewayId({ prodId: 6645743, qaId: null }),
    name: '[Plano Base 2026] Master',
    description: 'Mensal',
    amount: PRICE_BASE_UNIVERSAL_MASTER_MONTHLY,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'master',
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 32,
    gateway_id: resolveGatewayId({ prodId: 6645744, qaId: null }),
    name: '[Plano Base 2026] Ultimate',
    description: 'Mensal',
    amount: PRICE_BASE_UNIVERSAL_ULTIMATE_MONTHLY,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'ultimate',
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 24,
    gateway_id: resolveGatewayId({ prodId: 6645753, qaId: null }),
    name: '[Promoção 2026] Starter Anual Parcelado 20% OFF',
    description: 'Anual',
    amount: PRICE_BASE_UNIVERSAL_STARTER_ANNUAL,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'starter',
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 27,
    gateway_id: resolveGatewayId({ prodId: 6645754, qaId: null }),
    name: '[Promoção 2026] Master Anual Parcelado 20% OFF',
    description: 'Anual',
    amount: PRICE_BASE_UNIVERSAL_MASTER_ANNUAL,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'master',
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 33,
    gateway_id: resolveGatewayId({ prodId: 6645755, qaId: null }),
    name: '[Promoção 2026] Ultimate Anual Parcelado 20% OFF',
    description: 'Anual',
    amount: PRICE_BASE_UNIVERSAL_ULTIMATE_ANNUAL,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'ultimate',
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 911,
    gateway_id: resolveGatewayId({ prodId: 6645745, qaId: null }),
    name: '[Plano Base 2026] Starter + JusProcessos até 50 processos',
    description: 'Mensal',
    amount: 101.9,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'starter',
    jusprocessos: true,
    jusprocessos_count: 50,
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 912,
    gateway_id: resolveGatewayId({ prodId: 6645777, qaId: null }),
    name: '[PLANO BASE 2026] MASTER + JusProcessos até 50 processos',
    description: 'Mensal',
    amount: 121.9,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'master',
    jusprocessos: true,
    jusprocessos_count: 50,
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 913,
    gateway_id: resolveGatewayId({ prodId: 6645778, qaId: null }),
    name: '[PLANO BASE 2026] ULTIMATE + JusProcessos até 50 processos',
    description: 'Mensal',
    amount: 141.9,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'ultimate',
    jusprocessos: true,
    jusprocessos_count: 50,
    is_offer: false,
  },
  {
    id: 914,
    gateway_id: resolveGatewayId({ prodId: 6645845, qaId: null }),
    name: '[PROMOÇÃO 2026] STARTER ANUAL 20% + JusProcessos até 50 processos',
    description: 'Anual com 20% de desconto',
    amount: 1038.0,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'starter',
    jusprocessos: true,
    jusprocessos_count: 50,
    is_offer: true,
    affiliation_type: null,
  },
  {
    id: 915,
    gateway_id: resolveGatewayId({ prodId: 6645846, qaId: null }),
    name: '[PROMOÇÃO 2026] MASTER ANUAL 20% + JusProcessos até 50 processos',
    description: 'Anual com 20% de desconto',
    amount: 1230.0,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'master',
    jusprocessos: true,
    jusprocessos_count: 50,
    is_offer: true,
    affiliation_type: null,
  },
  {
    id: 916,
    gateway_id: resolveGatewayId({ prodId: 6645847, qaId: null }),
    name: '[PROMOÇÃO 2026] ULTIMATE ANUAL 20% + JusProcessos até 50 processos',
    description: 'Anual com 20% de desconto',
    amount: 1422.0,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'ultimate',
    jusprocessos: true,
    jusprocessos_count: 50,
    is_offer: true,
    affiliation_type: null,
  },
  {
    id: 917,
    gateway_id: resolveGatewayId({ prodId: 6645769, qaId: null }),
    name: '[PLANO BASE 2026] STARTER + JusProcessos até 200 processos',
    description: 'Mensal',
    amount: 176.9,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'starter',
    jusprocessos: true,
    jusprocessos_count: 200,
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 918,
    gateway_id: resolveGatewayId({ prodId: 6645746, qaId: null }),
    name: '[Plano Base 2026] Master + JusProcessos até 200 processos',
    description: 'Mensal',
    amount: 196.9,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'master',
    jusprocessos: true,
    jusprocessos_count: 200,
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 919,
    gateway_id: resolveGatewayId({ prodId: 6645773, qaId: null }),
    name: '[PLANO BASE 2026] Ultimate + JusProcessos até 200 processos',
    description: 'Mensal',
    amount: 216.9,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'ultimate',
    jusprocessos: true,
    jusprocessos_count: 200,
    is_offer: false,
  },
  {
    id: 920,
    gateway_id: resolveGatewayId({ prodId: 6645848, qaId: null }),
    name: '[PROMOÇÃO 2026] STARTER ANUAL 20% + JusProcessos até 200 processos',
    description: 'Anual com 20% de desconto',
    amount: 1938.0,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'starter',
    jusprocessos: true,
    jusprocessos_count: 200,
    is_offer: true,
    affiliation_type: null,
  },
  {
    id: 921,
    gateway_id: resolveGatewayId({ prodId: 6645849, qaId: null }),
    name: '[PROMOÇÃO 2026] MASTER ANUAL 20% + JusProcessos até 200 processos',
    description: 'Anual com 20% de desconto',
    amount: 2130.0,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'master',
    jusprocessos: true,
    jusprocessos_count: 200,
    is_offer: true,
    affiliation_type: null,
  },
  {
    id: 922,
    gateway_id: resolveGatewayId({ prodId: 6645850, qaId: null }),
    name: '[PROMOÇÃO 2026] ULTIMATE ANUAL 20%  + JusProcessos até 200 processos',
    description: 'Anual com 20% de desconto',
    amount: 2322.0,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'ultimate',
    jusprocessos: true,
    jusprocessos_count: 200,
    is_offer: true,
  },
  {
    id: 923,
    gateway_id: resolveGatewayId({ prodId: 6645779, qaId: null }),
    name: '[PLANO BASE 2026] STARTER + JusProcessos até 500 processos',
    description: 'Mensal',
    amount: 326.9,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'starter',
    jusprocessos: true,
    jusprocessos_count: 500,
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 924,
    gateway_id: resolveGatewayId({ prodId: 6645780, qaId: null }),
    name: '[PLANO BASE 2026] MASTER + JusProcessos até 500 processos',
    description: 'Mensal',
    amount: 346.9,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'master',
    jusprocessos: true,
    jusprocessos_count: 500,
    is_offer: false,
    affiliation_type: null,
  },
  {
    id: 925,
    gateway_id: resolveGatewayId({ prodId: 6645747, qaId: null }),
    name: '[Plano Base 2026] Ultimate + JusProcessos até 500 processos',
    description: 'Mensal',
    amount: 366.9,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'ultimate',
    jusprocessos: true,
    jusprocessos_count: 500,
    is_offer: false,
  },
  {
    id: 926,
    gateway_id: resolveGatewayId({ prodId: 6645851, qaId: null }),
    name: '[PROMOÇÃO 2026] STARTER ANUAL 20% + JusProcessos até 500 processos',
    description: 'Anual com 20% de desconto',
    amount: 3738.0,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'starter',
    jusprocessos: true,
    jusprocessos_count: 500,
    is_offer: true,
    affiliation_type: null,
  },
  {
    id: 927,
    gateway_id: resolveGatewayId({ prodId: 6645852, qaId: null }),
    name: '[PROMOÇÃO 2026] MASTER ANUAL 20% + JusProcessos até 500 processos',
    description: 'Anual com 20% de desconto',
    amount: 3930.0,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'master',
    jusprocessos: true,
    jusprocessos_count: 500,
    is_offer: true,
    affiliation_type: null,
  },
  {
    id: 928,
    gateway_id: resolveGatewayId({ prodId: 6645853, qaId: null }),
    name: '[PROMOÇÃO 2026] - ULTIMATE ANUAL 20% + JusProcessos até 500 processos',
    description: 'Anual com 20% de desconto',
    amount: 4122.0,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'ultimate',
    jusprocessos: true,
    jusprocessos_count: 500,
    is_offer: true,
    affiliation_type: null,
  },
  {
    id: 2720,
    gateway_id: resolveGatewayId({ prodId: 6660658, qaId: null }),
    name: 'CAAMG_STARTER',
    description: 'Mensal',
    amount: PRICE_CAAMG_STARTER_MONTHLY,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'starter',
    is_offer: false,
    affiliation_type: AFFILIATION_TYPES.CAAMG,
  },
  {
    id: 2721,
    gateway_id: resolveGatewayId({ prodId: 6660659, qaId: null }),
    name: 'CAAMG_MASTER',
    description: 'Mensal',
    amount: PRICE_CAAMG_MASTER_MONTHLY,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'master',
    is_offer: false,
    affiliation_type: AFFILIATION_TYPES.CAAMG,
  },
  {
    id: 2722,
    gateway_id: resolveGatewayId({ prodId: 6660660, qaId: null }),
    name: 'CAAMG_ULTIMATE',
    description: 'Mensal',
    amount: PRICE_CAAMG_ULTIMATE_MONTHLY,
    billingCycle: 'monthly',
    periodicity: 30,
    installments: 1,
    plan_type: 'ultimate',
    is_offer: false,
    affiliation_type: AFFILIATION_TYPES.CAAMG,
  },
  {
    id: 2787,
    gateway_id: resolveGatewayId({ prodId: 6679790, qaId: null }),
    name: 'CAAMG_STARTER_ANUAL – 12x de R$ 53,90 sem juros',
    description: 'Anual',
    amount: PRICE_CAAMG_STARTER_ANNUAL,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'starter',
    is_offer: false,
    affiliation_type: AFFILIATION_TYPES.CAAMG,
  },
  {
    id: 2788,
    gateway_id: resolveGatewayId({ prodId: 6679791, qaId: null }),
    name: 'CAAMG_MASTER_ANUAL – 12x de R$ 67,90 sem juros',
    description: 'Anual',
    amount: PRICE_CAAMG_MASTER_ANNUAL,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'master',
    is_offer: false,
    affiliation_type: AFFILIATION_TYPES.CAAMG,
  },
  {
    id: 2789,
    gateway_id: resolveGatewayId({ prodId: 6679793, qaId: null }),
    name: 'CAAMG_ULTIMATE_ANUAL – 12x de R$ 81,90 sem juros',
    description: 'Anual',
    amount: PRICE_CAAMG_ULTIMATE_ANNUAL,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'ultimate',
    is_offer: false,
    affiliation_type: AFFILIATION_TYPES.CAAMG,
  },
  {
    id: 5517,
    gateway_id: resolveGatewayId({ prodId: 6824259, qaId: null }),
    name: '[Promoção 2026] Ultimate Anual Parcelado (R$ 492,00 em 12x sem juros de 41,00)',
    description: '12x sem juros',
    amount: 492,
    billingCycle: 'annually',
    periodicity: 365,
    installments: 12,
    plan_type: 'ultimate',
    is_offer: true,
    reactivationOfferType: '2026',
  },
];

